import { defineComponent as n, computed as o, createElementBlock as c, openBlock as l, normalizeClass as m, toDisplayString as b } from "vue";
import { tw as t } from "../../utils/tailwind.js";
const u = ["title"], x = /* @__PURE__ */ n({
  name: "RevTag",
  __name: "Tag",
  props: {
    label: {},
    size: { default: "medium" },
    variant: {},
    variation: { default: "filled" }
  },
  setup(i) {
    const e = i, r = o(() => {
      const a = t`rounded-xs inline-block max-w-full truncate`, s = {
        filled: {
          small: t`caption-bold px-2 py-0`,
          medium: t`body-2-bold px-4 py-0`,
          large: t`body-1-bold px-4 py-0`
        },
        // line-height is customized to make sure the text is correctly aligned if a filled & outline variation
        // are on the same line
        outline: {
          small: t`caption-bold px-2 py-0 leading-[14px]`,
          medium: t`body-2-bold px-4 py-0 leading-[18px]`,
          large: t`body-1-bold px-4 py-0 leading-[22px]`
        }
      }, d = {
        filled: {
          primary: t`bg-static-info-max text-static-default-hi`,
          secondary: t`bg-static-default-mid text-static-default-hi`,
          info: t`bg-static-info-mid text-static-info-hi`,
          success: t`bg-static-success-mid text-static-success-hi`,
          warning: t`bg-static-warning-mid text-static-warning-hi`,
          danger: t`bg-static-danger-mid text-static-danger-hi`,
          alternate: t`bg-static-default-mid text-static-default-hi mood-purple`
        },
        outline: {
          primary: t`border-static-brand-hi text-static-default-hi border`,
          secondary: t`border-static-default-mid text-static-default-hi border`,
          info: t`border-static-info-mid text-static-info-hi border`,
          success: t`border-static-success-mid text-static-success-hi border`,
          warning: t`border-static-warning-mid text-static-warning-hi border`,
          danger: t`border-static-danger-mid text-static-danger-hi border`,
          alternate: t`border-static-default-mid text-static-default-hi mood-purple border`
        }
      };
      return [
        a,
        s[e.variation][e.size],
        d[e.variation][e.variant]
      ];
    });
    return (a, s) => (l(), c("span", {
      class: m(r.value),
      title: i.label
    }, b(i.label), 11, u));
  }
});
export {
  x as default
};
